export default __webpack_public_path__ + "static/media/image3.12ac4960.jpg";